<template id="modalbox">
  <div class="modal fade" :id="id" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" data-backdrop="static" data-keyboard="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-body">
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import utils from './Utils.vue'

export default {
  name: 'modalbox',
  props:['id', 'res', 'common_res'],
  data () {
    return {
      "modalVerticalCenterClass":".modal",
      "params":{},
      "timer":null,
      "msg":null,
      "button":null,
      "timeout_btn":null,
      "buttons":null
    }
  },
  computed: {
  },
  components: {
  },
  created: function() {
    var self = this;
    //self.centerModals($(this.modalVerticalCenterClass));
    //$(window).on('resize', self.centerModals);
    //console.log('modal', self.id);
    //$(window).on('resize', self.centerModals('#'+self.id));
  },
  methods: {
    show:function () {
      $('#'+this.id).modal('show');
    },
    close:function () {
      $('#'+this.id).modal('hide');
    },
    doButton:function (btn) {
      var self = this;
      if (self.timer != null) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      if (btn.func) {
        btn.func();
      } else {
        this.close();
      }
    },
    centerModals:function ($element) {
      //if (!$element) return;
      var self = this;
      var $modals;
      if ($element.length) {
        $modals = $element;
      } else {
        $modals = $(this.modalVerticalCenterClass + ':visible');
      }
      //console.log(self.id, $modals.length);
      $modals.each(function (i) {
        //console.log(i, $(this).attr('id'));
        var $clone = $(this).clone().css('display', 'block').appendTo('body');
        //var top = Math.round(($clone.height() - $clone.find('.modal-content').height()) / 2 * 0.8);
        var top = 100;
        top = top > 0 ? top : 0;
        $clone.remove();
        $(this).find('.modal-content').css("margin-top", top);
      });
    }
  },
  mounted: function() {
    var self = this;
    this.$root.$on('modal.'+this.id, data => {
      self.timeout_btn = null;
      if (data.msg != null) {
        self.msg = data.msg;
      }
      if (data.icon != null) {
        self.icon = data.icon ;
      } else {
        delete self.icon;
      }
      if (data.buttons != null) {
        self.buttons = data.buttons;
        for (var i=0;i<self.buttons.length;i++) {
          if (self.buttons[i].func != null && self.buttons[i].timeout == true) {
            self.timeout_btn = self.buttons[i];
          }
        }
      } else {
        delete self.buttons;
      }
      if (data.button != null) {
        self.button = data.button;
      } else {
        delete self.button;
      }
      if (data.timeout != null) {
        self.timer = setTimeout(function() {
          if (self.timeout_btn != null) {
            self.timeout_btn.func();
          } else {
            self.close();
          }
        }, data.timeout);
      }
      $('#'+self.id).modal(data.mode);
      if (data.params != null) {
        //this.$root.$emit('modal.params.'+this.id, data);
        Object.keys(data.params).forEach(function (key) {
          self.params[key] = data.params[key];
        })
        //setTimeout(function() {
        //  self.centerModals($('#'+self.id));
        //}, 100);
      } else {
        //self.centerModals($('#'+self.id));
      }
      self.$forceUpdate();
    });
    setTimeout(function() {
      self.centerModals($('#'+self.id));
      $(window).on('resize', self.centerModals($('#'+self.id)));
    }, 100);
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ModalBox.vue